import ResourceEditTabBase from "./ResourceEditTabBase.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { HasReminderBaseMixin } from "../../widget/mixins/HasReminderBaseMixin.jsx";
import {ALERT_TYPES, ReminderTypes} from "../../../other/constants/OtherKeys.jsx";

export default class ResourceRemindersTab extends HasReminderBaseMixin(
  ResourceEditTabBase
) {
  static get $name() {
    return "ResourceRemindersTab";
  }

  // Factoryable type name
  static get type() {
    return "resourcereminderstabV2";
  }

  get swivuDeepLinkSlug() {
    return "reminders";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.resourceEditorReminderTab;
  }

  getStoreData() {
    return this.project.reminderStore.query(
      (reminder) => reminder.entityType === this.entityType && reminder[this.recordType] === this.record.id && reminder.alertType === ALERT_TYPES.REMINDER && reminder.alertTag === "Reminder",
      true
    );
  }

  get entityType() {
    return ReminderTypes.resource;
  }

  get recordType() {
    return "resourceId";
  }
}

ResourceRemindersTab.initClass();
